const BASEURL = "https://apivst.vivekasoftek.com/api/";
// const BASEURL = "http://localhost:5001/api/";
const ABOUTUS = `${BASEURL}contact`;
const PRODUCTPAGE = `${BASEURL}demo-request`;
const CAREERS = `${BASEURL}career`;
const CORPORATETRAINING = `${BASEURL}enroll`;
const CONTACTUS = `${BASEURL}service-request`;

export { ABOUTUS, PRODUCTPAGE, CAREERS, CORPORATETRAINING, CONTACTUS };